<template>
  <div class="inscription-view-page disable-prefix-input-color">
    <!-- Back -->
    <div class="inscription-view-page__header__back">
      <app-back-button
        class="inscription-view-page__header__back"
        :route-name="tabName ? 'subpropertyPeople' : null"
        :route-params="{ tabName, subtabName }"
        :i18n-code="tabName ? 'entities.inscription.list.title' : ''"
      />
    </div>
    <div class="inscription-view-page__header">
      <!-- Title -->
      <div class="inscription-view-page__header__title">
        <h1 class="app-content-title">
          <template v-if="!loading">
            <strong>{{ namePlayer }}</strong>
            <span>&nbsp;·&nbsp;</span>
            {{presenterProgram(record.program, 'type')}}
            {{presenterProgram(record.program, 'name')}}
            <span
              class="app-content-title--margin"
            >&nbsp;·&nbsp;</span>
            {{presenterSubprogram(record.subprogram, 'name')}}
          </template>
        </h1>
      </div>

      <!-- Change Status -->
      <div class="inscription-view-page__header__change-status">
        <inscription-change-status
          v-if="record"
          :inscriptionData="record"
          :subpropertyId="subpropertyId"
          :onFinishSubmitFn="doOnFinishSubmit"
          :doNavigation="false"
        />
      </div>
    </div>

    <div
      class="app-content-page inscription-view-page__content"
      v-if="loading"
      v-loading="loading"
    />

    <div v-else-if="record" class="app-content-page inscription-view-page__content">
      <h2 class="app-content-subtitle">
        <span v-text="parentFullName" />
        <span class="inscription-view-page--margin-dot inscription-view-page--color-gray">·</span>
        <app-i18n
          code="entities.inscription.view.subtitle.familyMember"
          class="inscription-view-page--color-gray"
        />
      </h2>

      <!-- Family member -->
      <el-row :gutter="10">
        <!-- Card parent -->
        <el-col :lg="10" :md="10" :sm="24">
          <app-view-card
            v-if="parentCardParams"
            :titleI18n="parentCardParams.titleI18n"
            :fieldsValuesArray="parentCardParams.fieldsValuesArray"
            :icon="parentCardParams.icon"
          />
        </el-col>

        <!-- Card address -->
        <el-col :lg="14" :md="14" :sm="24">
          <app-view-card
            v-if="addressCardParams"
            :titleI18n="addressCardParams.titleI18n"
            :fieldsValuesArray="addressCardParams.fieldsValuesArray"
            :icon="addressCardParams.icon"
          />
        </el-col>
      </el-row>

      <h2 class="app-content-subtitle">
        <span v-text="namePlayer" />
        <span class="inscription-view-page--margin-dot inscription-view-page--color-gray">·</span>
        <app-i18n
          code="entities.inscription.view.subtitle.player"
          class="inscription-view-page--color-gray"
        />
      </h2>

      <!-- Player info member -->
      <el-row :gutter="10">
        <!-- Player -->
        <el-col :lg="10" :md="10" :sm="24">
          <app-view-card
            v-if="playerCardParams"
            :titleI18n="playerCardParams.titleI18n"
            :fieldsValuesArray="playerCardParams.fieldsValuesArray"
            :icon="playerCardParams.icon"
          />
        </el-col>

        <el-col :lg="14" :md="14" :sm="24">
          <!-- Additional docs -->
          <app-view-card
            v-if="additionalDocCardParams.fieldsValuesArray.length"
            :titleI18n="additionalDocCardParams.titleI18n"
            :description="additionalDocCardParams.description"
            :fieldsValuesArray="additionalDocCardParams.fieldsValuesArray"
            :icon="additionalDocCardParams.icon"
          />
        </el-col>

        <!-- <el-col :lg="14" :md="14" :sm="24">
           <app-view-card 
            v-if="programCardParams"
            :titleI18n="programCardParams.titleI18n" 
            :fieldsValuesArray="programCardParams.fieldsValuesArray"
            :icon="programCardParams.icon"
          />
        </el-col>-->
      </el-row>

      <!-- Player verification -->
      <!-- <el-row :gutter="10">
        <el-col :lg="10" :md="10" :sm="24">
           <app-view-card 
            v-if="verificacionCardParams"
            :titleI18n="verificacionCardParams.titleI18n" 
            :fieldsValuesArray="verificacionCardParams.fieldsValuesArray"
            :icon="verificacionCardParams.icon"
          />
        </el-col>
      </el-row>-->

      <h2 v-if="isPayment" class="app-content-subtitle">
        <app-i18n code="entities.stripe.totalAmount.title" />
        <span class="inscription-view-page--margin-dot inscription-view-page--color-gray">·</span>
        <app-i18n code="entities.stripe.payment" class="inscription-view-page--color-gray" />
      </h2>

      <!-- Total amount -->
      <el-row :gutter="10">
        <!-- Paid -->
        <el-col :lg="9" :md="9" :sm="24">
          <app-view-card
            v-if="isPayment"
            :titleI18n="paidCardParams.titleI18n"
            :fieldsValuesArray="paidCardParams.fieldsValuesArray"
            :icon="paidCardParams.icon"
          />
        </el-col>

        <!-- Pending -->
        <!-- <el-col :lg="9" :md="9" :sm="24">
          <app-view-card 
            v-if="pendingCardParams"
            :titleI18n="pendingCardParams.titleI18n" 
            :fieldsValuesArray="pendingCardParams.fieldsValuesArray"
            :icon="pendingCardParams.icon"
          />
        </el-col>-->
      </el-row>

      <!-- Charges -->
      <app-stripe-charge-list-page 
        v-if="isPayment"
        :inscriptionId="id"
      >
        <div 
          slot="title"
          class="app-content-subtitle"
        >
          <app-i18n code="entities.stripe.charges.title" />
        </div>
      </app-stripe-charge-list-page>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InscriptionViewToolbar from '@modules/inscription/components/inscription-view-toolbar.vue';
import { InscriptionModel } from '@modules/inscription/inscription-model';
import { ProgramModel } from '@modules/program/program-model';
import { SubprogramModel } from '@modules/subprogram/subprogram-model';
import { UserModel } from '@modules/auth/user-model';
import { AddressModel } from '@shared/model/address-model';
import { StripeChargeModel } from '@modules/stripe/stripe-charge/stripe-charge-model';
import InscriptionChangeStatus from '@modules/inscription/components/inscription-change-status.vue';
import StrinpeChargeListPage from '@modules/stripe/stripe-charge/components/stripe-charge-list-page.vue';
import TagsFactory from '@shared/factories/tags-factory';
import { get } from 'lodash';
// import "i18n-number/i18n-number.js";

const IS_DISABLED_STATUS_ACTION = true;

export default {
  name: 'app-inscription-view-page',

  props: {
    id: {
      type: String,
      required: true,
    },

    tabName: {
      type: String,
    },
    subtabName: {
      type: String,
    },

    subpropertyId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      dialogVisible: false,
      selectedRow: '',
      previousStatus: '',
      teamListTransferKey: 0,
      listTeamPlayer: [],
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'inscription/view/record',
      amount: 'inscription/view/amount',
      loading: 'inscription/view/loading',
      populateDate: 'auth/manage/populateDate',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    fields() {
      const { dateFormat } = this;
      return InscriptionModel.fields({
        propertyName: '',
        dateFormat,
      });
    },

    isDisableStatusAction() {
      return IS_DISABLED_STATUS_ACTION;
    },

    isPayment() {
      return get(this.record, 'subprogram.payment.exist', false)
    },
    namePlayer() {
      if (
        this.record &&
        this.record.firstName &&
        this.record.lastName
      )
        return (
          this.record.firstName + ' ' + this.record.lastName
        );
      else return '';
    },

    parentFullName() {
      if (
        this.record &&
        this.record.user &&
        this.record.user.firstName &&
        this.record.user.lastName
      )
        return (
          this.record.user.firstName +
          ' ' +
          this.record.user.lastName
        );
      else return '';
    },

    parentCardParams() {
      if (this.record && this.record.user) {
        return {
          icon: 'icon-player',
          titleI18n:
            'entities.inscription.view.card.information',
          fieldsValuesArray: [
            {
              fieldI18n: 'user.fields.gender',
              value: this.presenterUser(
                this.record.user,
                'gender',
              ),
              col: { lg: 24, md: 24, sm: 24 },
            },
            {
              fieldI18n: 'user.fields.birthdate',
              value: this.presenterUser(
                this.record.user,
                'birthdate',
              ),
              col: { lg: 24, md: 24, sm: 24 },
            },
            {
              fieldI18n: 'user.fields.phoneNumber',
              value: this.presenterUser(
                this.record.user,
                'phoneNumber',
              ),
              col: { lg: 24, md: 24, sm: 24 },
            },
            {
              fieldI18n: 'user.fields.email',
              value: this.presenterUser(
                this.record.user,
                'email',
              ),
              col: { lg: 24, md: 24, sm: 24 },
            },
            {
              fieldI18n: 'user.fields.identDoc',
              value: this.presenterUser(
                this.record.user,
                'identDoc',
              ),
              // disabled: this.record.user,
              col: { lg: 24, md: 24, sm: 24 },
            },
          ],
        };
      }

      return null;
    },

    addressCardParams() {
      if (this.record && this.record.user) {
        const { address } = this.record.user;

        return {
          icon: 'icon-location',
          titleI18n:
            'entities.inscription.view.card.address',
          fieldsValuesArray: [
            {
              fieldI18n:
                'entities.inscription.view.card.address',
              value: this.presenterAddress(
                address,
                'line1',
              ),
              col: { lg: 24, md: 24, sm: 24 },
            },
            {
              fieldI18n: 'entities.address.fields.city',
              value: this.presenterAddress(address, 'city'),
              col: { lg: 24, md: 24, sm: 24 },
            },
            {
              fieldI18n: 'entities.address.fields.state',
              value: this.presenterAddress(
                address,
                'state',
              ),
              col: { lg: 24, md: 24, sm: 24 },
            },
            {
              fieldI18n:
                'entities.address.fields.postalCode',
              value: this.presenterAddress(
                address,
                'postalCode',
              ),
              col: { lg: 24, md: 24, sm: 24 },
            },
          ],
        };
      }
      return null;
    },

    playerCardParams() {
      return {
        icon: 'icon-player',
        titleI18n:
          'entities.inscription.view.card.information',
        fieldsValuesArray: [
          {
            fieldI18n: 'entities.inscription.fields.gender',
            value: this.presenter(this.record, 'gender'),
            col: { lg: 24, md: 24, sm: 24 },
          },
          {
            fieldI18n:
              'entities.inscription.fields.birthdate',
            value: this.presenter(this.record, 'birthdate'),
            col: { lg: 24, md: 24, sm: 24 },
          },
          {
            fieldI18n:
              'entities.inscription.view.fields.isMember',
            value: this.presenter(this.record, 'isMember'),
            col: { lg: 24, md: 24, sm: 24 },
          },
          {
            fieldI18n:
              'entities.inscription.fields.careerInfo',
            value: this.presenter(
              this.record,
              'careerInfo',
            ),
            disabled: this.record.isMember,
            col: { lg: 24, md: 24, sm: 24 },
          },
          {
            fieldI18n:
              'entities.inscription.fields.identDoc',
            value: this.presenter(this.record, 'identDoc'),
            col: { lg: 24, md: 24, sm: 24 },
          },
          {
            fieldI18n:
              'entities.inscription.fields.subprogram',
            files: this.record.identDocFiles,
            refKey: 'identDocFiles',
            col: { lg: 24, md: 24, sm: 24 },
          },
        ],
      };
    },

    programCardParams() {
      return {
        icon: 'icon-teams',
        titleI18n: 'entities.program.label.one',
        fieldsValuesArray: [
          {
            fieldI18n: 'entities.program.fields.type',
            value: this.presenterProgram(
              this.record.program,
              'type',
            ),
            col: { lg: 24, md: 24, sm: 24 },
          },
          {
            fieldI18n: 'entities.program.label.one',
            value: this.presenterProgram(
              this.record.program,
              'name',
            ),
            col: { lg: 24, md: 24, sm: 24 },
          },
          {
            fieldI18n:
              'entities.inscription.fields.subprogram',
            value: this.presenterSubprogram(
              this.record.subprogram,
              'name',
            ),
            col: { lg: 24, md: 24, sm: 24 },
          },
        ],
      };
    },

    verificacionCardParams() {
      return {
        icon: 'icon-accept',
        titleI18n:
          'entities.inscription.view.card.verification',
        fieldsValuesArray: [
          {
            fieldI18n:
              'entities.inscription.fields.identDoc',
            value: this.presenter(this.record, 'identDoc'),
            col: { lg: 24, md: 24, sm: 24 },
          },
          {
            fieldI18n:
              'entities.inscription.fields.subprogram',
            files: this.record.identDocFiles,
            refKey: 'identDocFiles',
            col: { lg: 24, md: 24, sm: 24 },
          },
        ],
      };
    },

    additionalDocCardParams() {
      const {
        text: description,
      } = this.presenterSubprogram(
        this.record.subprogram,
        'additionalDoc',
      );

      return {
        icon: 'icon-document',
        titleI18n:
          'entities.inscription.view.card.aditionaDocuments',
        description: description ? description : null,
        fieldsValuesArray: [
          {
            fieldI18n:
              'entities.inscription.view.card.aditionaDocuments',
            files: this.record.additionalDocFiles,
            refKey: 'additionalDocFiles',
            col: { lg: 24, md: 24, sm: 24 },
          },
        ],
      };
    },

    totalPaid({ isPayment }) {
      if ( isPayment && this.record.charges) {
        var arrayTotal = [];
        this.record.charges.map(function(charge) {
          arrayTotal.push(charge.amount);
        });
        return arrayTotal.reduce((a, b) => a + b, 0);
      }
      return 0;
    },

    paidCardParams() {
      return {
        icon: 'icon-card',
        titleI18n: 'entities.stripe.totalAmount.card.paid',
        fieldsValuesArray: [
          {
            fieldI18n: '',
            amount: this.totalPaid,
            currency: get(this.record, 'charges[0].currency',''),
            currencyDisplay: 'symbol',
            col: { lg: 24, md: 24, sm: 24 },
            style: {
              fontSize: '24px',
              color: '#4c4c4c',
              textTransform: 'uppercase',
            },
          },
        ],
      };
    },

    pendingCardParams() {
      return {
        icon: 'icon-box',
        titleI18n:
          'entities.stripe.totalAmount.card.pending',
        fieldsValuesArray: [
          {
            fieldI18n: '',
            value:
              this.amount.pending.amount +
              ' ' +
              this.amount.pending.currency,
            col: { lg: 24, md: 24, sm: 24 },
            style: {
              fontSize: '24px',
              color: '#4c4c4c',
              textTransform: 'uppercase',
            },
          },
        ],
      };
    },
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'inscription/view/doFind',
      doFindBalance: 'inscription/view/doFindBalance',
      doChangeStatus: 'inscription/form/doChangeStatus',
    }),

    presenter(record, fieldName) {
      const { dateFormat } = this;
      return InscriptionModel.presenter(
        record,
        fieldName,
        '',
        dateFormat,
      );
    },

    presenterProgram(record, fieldName) {
      return ProgramModel.presenter(record, fieldName);
    },

    presenterSubprogram(record, fieldName) {
      const { dateFormat, populateDate } = this;
      return new SubprogramModel({
        dateFormat,
        populateDate,
      }).presenter(record, fieldName);
    },

    presenterUser(record, fieldName) {
      const { dateFormat } = this;
      return new UserModel({ dateFormat }).presenter(
        record,
        fieldName,
      );
    },

    presenterAddress(record, fieldName) {
      if (!record) return;
      return AddressModel.presenter(record, fieldName);
    },
    presenterCharge(record, fieldName) {
      return StripeChargeModel.presenter(record, fieldName);
    },

    doOnFinishSubmit() {},

    getTagStyle(keyEnum, valueEnum) {
      return new TagsFactory({
        entityName: 'stripeCharges',
      }).getTagStyle({
        keyEnum: keyEnum,
        valueEnum: valueEnum,
      });
    },
  },

  components: {
    [InscriptionChangeStatus.name]: InscriptionChangeStatus,
    [InscriptionViewToolbar.name]: InscriptionViewToolbar,
    [StrinpeChargeListPage.name]: StrinpeChargeListPage,
  },
};
</script>

<style lang="scss" scoped>
.inscription-view-page {
  &__header {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-template-rows: 60px;
    align-items: center;
    &__title {
      h1 {
        font-size: 18px;
      }
      .app-content-title--margin {
        margin: -6px;
      }
    }
  }

  &__content {
    padding: 3% 3%;
    font-size: 14px;
  }

  // Modifiers
  &--color-gray {
    color: #c5c5c5;
  }
  &--margin-dot {
    margin: 0.3rem;
  }
  &--padding-row-field {
    margin: 0.5rem;
  }
}

.inscription-view-page__content__charges {
  padding-bottom: 10%;

  &__status {
    width: 120px;
    border-radius: 7px;
    text-transform: capitalize;
    box-shadow: 0 2px 5px 0 rgba(223, 223, 223, 0.7);
    font-weight: 500;
    letter-spacing: 0;
    padding: 10px 0px 6px 12px;

    display: grid;
    grid-template-areas: 'dot label';
    grid-template-columns: 20px;
    grid-template-rows: 20px;
    align-items: center;
  }

  &__fee {
    display: grid;
    &--small {
      font-size: 10px;
      color: rgba(125, 125, 125, 0.74);
    }
  }

  &__card {
    display: grid;
    grid-template-areas: 'icon last4';
    align-items: center;

    &__img {
      width: 40px;
      grid-area: icon;
    }

    &__last4 {
      grid-area: last4;
    }
  }

  .app-content-title--margin {
    margin: 5px;
  }
}
</style>
